import vasomotorIcon from "../assets/images/vasomotor_icon.png";
import physicalIcon from "../assets/images/physical_icon.png";
import moodMentalIcon from "../assets/images/mood_and_mental_icon.png";
import sleepIcon from "../assets/images/sleep_icon.png";
import healthIcon from "../assets/images/health_icon.png";
import vasomotorHeaderIcon from "../assets/images/vasomotor_header_icon.png";
import physicalHeaderIcon from "../assets/images/physical_header_icon.png";
import moodMentalHeaderIcon from "../assets/images/mood_and_mental_header_icon.png";
import healthHeaderIcon from "../assets/images/health_header_icon.png";
import { ThemeColor } from "models/ratingCheckbox";
import hotflushCircleicon from "assets/images/hotflushesicon.png";
import libidoCircleicon from "assets/images/libidoicon.png";
import sleepCircleicon from "assets/images/sleepicon.png";
import sleepBgPurple from "assets/images/sleep_bg_white.png";
import { CategoryType } from "models/symptomTracker";
import dropletIcon from "assets/images/droplet-icon.png";
import highImpactIcon from "assets/images/high-impact-icon.png";
import mediumImpactIcon from "assets/images/medium-impact-icon.png";
import lowImpactIcon from "assets/images/low-impact-icon.png";
import moodMentalCircleIcon from "assets/images/mood-mental-icon.png";
import physicalCircleIcon from "assets/images/physical-icon.png";
import physicalCategoryIcon from "assets/images/physical-category-icon.png";
import radio from "assets/images/radio.png";
import zoom from "assets/images/zoom.png";
import statistics from "assets/images/statistics.png";
import book from "assets/images/book.png";
import excellentEmoji from "assets/images/excellent_emoji.png";
import goodEmoji from "assets/images/good_emoji.png";
import fairEmoji from "assets/images/fair_emoji.png";
import badEmoji from "assets/images/bad_emoji.png";
import unsureEmoji from "assets/images/unsure_emoji.png";

export const BTN_VARIANTS = {
  PRIMARY: "btn_primary",
  SUB_PRIMARY: "btn_sub_primary",
  SECONDARY: "btn_secondary",
  SECONDARY_SHADOW: "btn_secondary_shadow",
  LINK: "btn_link",
  SECONDARY_WHITE: "btn_secondary_white",
  DARK: "btn_dark",
  NEUTRAL: "btn_neutral",
};

export const BTN_SIZE = {
  LARGE: "btn_large",
  DEFAULT: "btn_default",
  SMALL: "btn_small",
  FULLWIDTH: "btn_fullwidth",
  XLARG: "btn_xlarg",
  NEUTRAL: "",
};

export const BTN_MODE = { NORMAL: "normal", LINK: "link" };

export const AVTR_SIZE = { LARGE: "avtr_large", MEDIUM: "avtr_medium" };

export const CONSENT_LAYOUT_VARIANTS = {
  DEFAULT: "default",
  FIXED: "fixed",
  CUSTOM: "custom",
} as const;

export const CURVED_DIVIDER = {
  TOP: "top",
  BOTTOM: "bottom",
  RED_PRIMARY: "#a12136",
  RED_SECONDARY: "#de271f",
  GREY: "#f4f4f4",
  WHITE: "#fff",
  RED_100: "#FDCBCB",
  RED_50: "#FEDEEB",
  RED_60: "#FCE9E9",
  RED_GRADIENT_PINK: "#feeaea",
  RED_BG_NEW: "rgba(252, 233, 233, 1)",
};

export const ARTICLE_BUTTON_TYPE = {
  PINK: "bg_pink",
  YELLOW: "bg_yellow",
  BLUE: "bg_blue",
  PURPLE: "bg_purple",
};

export const DRPDWN_SIZE = {
  LARGE: "drpdwn_primary",
  DEFAULT: "drpdwn_default",
};

export const DRPDWN_PLACEMENTS = { bottom_left: "bottomLeft" };

export const DRPDWN_PLACEHOLDER = {
  profile_dropdown_placeholder: "Select an option",
  filter_by: "Filter by",
};

export const DATE_SIZE = {
  LARGE: "dateSelector_primary",
};

export const CTM_BTN = {
  custom_button_secondary: "custom_btn_secondary",
  DEFAULT: "btn_default",
};

export const TEXTFIELD_SIZE = {
  LARGE: "textField_primary",
  DEFAULT: "textField_default",
};

export const COLORS = [
  { color: "#A92317", name: "High" },
  { color: "#D75E53", name: "Medium" },
  { color: "#F8AFA8", name: "Low" },
  { color: "#E5BDB9", name: "None" },
];

export const RED_400 = "#DE271F";
export const RED_500 = "#A12136";
export const RED_MID = "#DE271F99";
export const LIGHT_RED = "#DE271F4D";
export const VERY_LIGHT_RED = "#DE271F33";
export const YELLOW = "#FFA71D";
export const YELLOW_MID = "#FFA71D99";
export const LIGHT_YELLOW = "#FFA71D4D";
export const VERY_LIGHT_YELLOW = "#FFA71D33";
export const GREEN = "#1BB271";
export const GREEN_MID = "#1BB27199";
export const LIGHT_GREEN = "#1BB2714D";
export const VERY_LIGHT_GREEN = "#1BB27133";
export const PINK = "#FF92BE";
export const PINK_MID = "#FF92BE99";
export const LIGHT_PINK = "#FF92BE4D";
export const VERY_LIGHT_PINK = "#FF92BE33";
export const PINK_100 = "#FEDEEB";
export const WHITE = "#ffffff";
export const PURPLE = "#AA95DB";
export const PURPLE_MID = "#AA95DB99";
export const LIGHT_PURPLE = "#AA95DB4D";
export const VERY_LIGHT_PURPLE = "#AA95DB33";
export const GRAY_100 = "#f4f4f4";
export const GRAY_200 = "#EAEAEA";
export const GRAY_300 = "#777777";
export const ICON_BACKGROUND_GRAY = "#E2E2E2";
export const BACKGROUND_GRAY = "#d9d9d9";
export const PRIMARY_SUB = "#ED8BB2";

export const SYMPTOM_TRACKER_COLOR = {
  RED: {
    radio: RED_400,
    highTrack: RED_400,
    mediumTrack: RED_MID,
    lowTrack: LIGHT_RED,
  },
  YELLOW: {
    radio: YELLOW,
    highTrack: YELLOW,
    mediumTrack: YELLOW_MID,
    lowTrack: LIGHT_YELLOW,
  },
  GREEN: {
    radio: GREEN,
    highTrack: GREEN,
    mediumTrack: GREEN_MID,
    lowTrack: LIGHT_GREEN,
  },
  PURPLE: {
    radio: PURPLE,
    highTrack: PURPLE,
    mediumTrack: PURPLE_MID,
    lowTrack: LIGHT_PURPLE,
  },
  PINK: {
    radio: PINK,
    highTrack: PINK,
    mediumTrack: PINK_MID,
    lowTrack: LIGHT_PINK,
  },
};
export const SYMPTOM_TRACK_LIST = [
  {
    id: null,
    title: "",
    dummyTitle: CategoryType.VASOMOTOR,
    icon: vasomotorIcon,
    backgroundColor: LIGHT_RED,
    status: "",
    statusColor: RED_400,
    headerIcon: vasomotorHeaderIcon,
    themeColor: ThemeColor.RED,
  },
  {
    id: null,
    title: "",
    dummyTitle: CategoryType.PHYSICAL,
    icon: physicalIcon,
    backgroundColor: LIGHT_YELLOW,
    status: null,
    statusColor: YELLOW,
    headerIcon: physicalHeaderIcon,
    themeColor: ThemeColor.YELLOW,
  },
  {
    id: null,
    title: "",
    dummyTitle: CategoryType.MOOD_AND_MENTAL,
    icon: moodMentalIcon,
    backgroundColor: LIGHT_GREEN,
    status: "",
    statusColor: GREEN,
    headerIcon: moodMentalHeaderIcon,
    themeColor: ThemeColor.GREEN,
  },
  {
    id: null,
    title: "",
    dummyTitle: CategoryType.SLEEP,
    icon: sleepIcon,
    backgroundColor: LIGHT_PURPLE,
    status: "",
    statusColor: PURPLE,
    headerIcon: sleepBgPurple,
    themeColor: ThemeColor.PURPLE,
  },
  {
    id: null,
    title: "",
    dummyTitle: CategoryType.SEXUAL_AND_URINARY_HEALTH,
    icon: healthIcon,
    backgroundColor: LIGHT_PINK,
    status: "",
    statusColor: PINK,
    headerIcon: healthHeaderIcon,
    themeColor: ThemeColor.PINK,
  },
];

export const MQ6_ASSESSMENT_STATIC_DATA = {
  GUIDE: {
    LONG_DESC:
      '<p>Find around 3 minutes to answer the following six questions*. If you answer "yes" to any, don’t hesitate to speak to your doctor or pharmacist for further guidance. To receive your personalised results, you’ll be asked to sign up at the end.<p>',
    SHORT_DESC:
      "*The Menopause Quick 6 (MQ6) questionnaire has been adapted and reproduced with permission from the College of Family Physicians of Canada from: Goldstein S. An efficient tool for the primary care management of menopause. Can Fam Physician. 2017 Apr;63(4):295-298",
    SHORT_DESC_2:
      "This guide is brought to you by CanesMeno®. The CanesMeno®Guide can only provide education about stages of Menopause and signs, it is not intended to be a substitute for advice from your doctor. It is not a medical device and should not be used as a diagnostic tool. If you are unsure, please speak to your doctor.",
  },

  ABOUT: {
    LONG_DESC:
      "<p>Tell us about yourself so we can personalise your menopause guidance and provide you the education best suited to your individual needs.</p>",
    SHORT_DESC: "",
  },
};
export const CATEGORYCARD_BACKGROUNDCOLOR = {
  BROWN: "bg_yellow",
  BLUE: "bg_blue",
  PINK: "bg_pink",
};

export const INSIGHTS_CARD_ICONS = [
  {
    category_id: 1,
    image: hotflushCircleicon,
  },
  {
    category_id: 2,
    image: physicalCircleIcon,
  },
  {
    category_id: 3,
    image: moodMentalCircleIcon,
  },
  {
    category_id: 4,
    image: sleepCircleicon,
  },
  {
    category_id: 5,
    image: libidoCircleicon,
  },
];

export const INSIGHTS_ON_PATTERN_ICONS = [
  {
    impact: "PERIODS",
    image: dropletIcon,
  },
  {
    impact: "HIGH",
    image: highImpactIcon,
  },
  {
    impact: "MEDIUM",
    image: mediumImpactIcon,
  },
  {
    impact: "LOW",
    image: lowImpactIcon,
  },
];

export const INSIGHTS_PROGRESS_DATA = [
  {
    category_id: 1,
    icon: vasomotorIcon,
    imgBackgroundColor: RED_400,
    trailColor: VERY_LIGHT_RED,
    iconWidth: 22,
  },
  {
    category_id: 2,
    icon: physicalCategoryIcon,
    imgBackgroundColor: YELLOW,
    trailColor: VERY_LIGHT_YELLOW,
    iconWidth: 36,
  },
  {
    category_id: 3,
    icon: moodMentalIcon,
    imgBackgroundColor: GREEN,
    trailColor: VERY_LIGHT_GREEN,
    iconWidth: 30,
  },
  {
    category_id: 4,
    icon: sleepIcon,
    imgBackgroundColor: PURPLE,
    trailColor: VERY_LIGHT_PURPLE,
    iconWidth: 29,
  },
  {
    category_id: 5,
    icon: healthIcon,
    imgBackgroundColor: PINK,
    trailColor: VERY_LIGHT_PINK,
    iconWidth: 36,
  },
];

// contants added for response message(error) handling
export const RESPONSE_MESSAGES = {
  SUCCESS: "Successful", // success message to be displayed
  ERROR: "Error", //error message to be displayed
  ERROR_CUSTOM: "ErrorCustom",
  UPLOAD_FAILED: "Upload Failed. Please try again.",
  UPLOAD_VALIDATION: "You can only upload JPG, JPEG, or PNG files.",
  REMOVE_FAILED: "Failed to remove profile picture. Please try again.",
};

export const WELCOME_TILES = [
  {
    heading: "Your CanesMeno® Guide",
    content:
      "Interested in finding out more about Menopause? Take our CanesMeno® Guide survey.",
    cardColors: { bg: "#FFE2E6", icon_bg: "#FAD2D8" },
    icon: book,
  },
  {
    heading: "Track your Signs",
    content:
      "Easily track and monitor your menopause experience, such as hot flushes and night sweats, mood swings or sleep disturbances.",
    cardColors: { bg: "#E3F1FE", icon_bg: "#D4E7F8" },
    icon: radio,
  },
  {
    heading: "Gain Insights",
    content:
      "Gain personal insights into your experiences over time, identify patterns, and understand how these changes impact your life.",
    cardColors: { bg: "#DFFBED", icon_bg: "#C2F0D9" },
    icon: statistics,
  },
  {
    heading: "Explore",
    content:
      "Explore articles about menopause and learn how to equip yourself to navigate this transformative lifestage.",
    cardColors: { bg: "#FEF9E4", icon_bg: "#F8EFC9" },
    icon: zoom,
  },
];

// The data inside emoji card
export const EMOJI_DATA = [
  {
    id: 0,
    title: "Excellent",
    iconType: excellentEmoji,
  },
  {
    id: 1,
    title: "Good",
    iconType: goodEmoji,
  },
  {
    id: 2,
    title: "Fair",
    iconType: fairEmoji,
  },
  {
    id: 3,
    title: "Bad",
    iconType: badEmoji,
  },
  {
    id: 4,
    title: "Unsure",
    iconType: unsureEmoji,
  },
];

export const ACCORDION_VARIANTS = {
  DEFAULT: "default",
  PRODUCT_DETAIL: "product_detail",
};
